import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import * as actionTypes from './constants';

export const items = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      'NAVIGATION_DETAILS_REQUEST',
      actionTypes.TIMELINE_REQUEST,
    )]: () => [],
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => payload.items,
    [actionTypes.TIMELINE_SUCCESS_FUTURE]: (state, { payload }) => [
      ...payload.items,
      ...state,
    ],
    [actionTypes.TIMELINE_SUCCESS_PAST]: (state, { payload }) => [
      ...state,
      ...payload.items,
    ],
  },
  [],
);

// No isLoading to be shown when handling past requests,
// as these are managed by infinite scrolling.
export const isLoading = handleActions(
  {
    [actionTypes.TIMELINE_REQUEST]: () => true,
    [actionTypes.TIMELINE_SUCCESS]: () => false,
    [actionTypes.TIMELINE_FAILURE]: () => false,
    [actionTypes.TIMELINE_REQUEST_FUTURE]: () => true,
    [actionTypes.TIMELINE_SUCCESS_FUTURE]: () => false,
    [actionTypes.TIMELINE_FAILURE_FUTURE]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.TIMELINE_REQUEST,
      actionTypes.TIMELINE_SUCCESS,
      actionTypes.TIMELINE_REQUEST_FUTURE,
      actionTypes.TIMELINE_SUCCESS_FUTURE,
      actionTypes.TIMELINE_REQUEST_PAST,
      actionTypes.TIMELINE_SUCCESS_PAST,
    )]: () => ({}),
    [combineActions(
      actionTypes.TIMELINE_FAILURE,
      actionTypes.TIMELINE_FAILURE_FUTURE,
      actionTypes.TIMELINE_FAILURE_PAST,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const filters = handleActions(
  {
    [actionTypes.TIMELINE_REQUEST]: state => state.length ? state : [],
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => payload.filter,
    [actionTypes.TIMELINE_SUCCESS_FUTURE]: (state, { payload }) =>
      payload.filter,
    [actionTypes.TIMELINE_SUCCESS_PAST]: (state, { payload }) => payload.filter,
  },
  [],
);

export const statusses = handleActions(
  {
    [actionTypes.TIMELINE_REQUEST]: state => state.length ? state : [],
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => payload.status,
    [actionTypes.TIMELINE_SUCCESS_FUTURE]: (state, { payload }) =>
      payload.status,
    [actionTypes.TIMELINE_SUCCESS_PAST]: (state, { payload }) => payload.status,
  },
  [],
);

export const isInactive = handleActions(
  {
    [combineActions(
      actionTypes.TIMELINE_REQUEST,
      actionTypes.TIMELINE_FAILURE,
    )]: () => true,
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => !!payload?.isInactive,
  },
  true,
);

export const objects = handleActions(
  {
    [actionTypes.TIMELINE_REQUEST]: state => state.length ? state : [],
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => payload.object,
    [actionTypes.TIMELINE_SUCCESS_FUTURE]: (state, { payload }) =>
      payload.object,
    [actionTypes.TIMELINE_SUCCESS_PAST]: (state, { payload }) => payload.object,
  },
  [],
);

export const types = handleActions(
  {
    [actionTypes.TIMELINE_REQUEST]: state => state.length ? state : [],
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => payload.type,
    [actionTypes.TIMELINE_SUCCESS_FUTURE]: (state, { payload }) =>
      payload.type,
    [actionTypes.TIMELINE_SUCCESS_PAST]: (state, { payload }) => payload.type,
  },
  [],
);

export const futureDate = handleActions(
  {
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => {
      if (payload.future && payload.future.query) {
        return payload.future.query.date;
      }
      return '';
    },
    [actionTypes.TIMELINE_SUCCESS_FUTURE]: (state, { payload }) => {
      if (payload.future && payload.future.query) {
        return payload.future.query.date;
      }
      return '';
    },
  },
  '',
);

export const pastDate = handleActions(
  {
    [actionTypes.TIMELINE_SUCCESS]: (state, { payload }) => {
      if (payload.past && payload.past.query) {
        return payload.past.query.date;
      }
      return '';
    },
    [actionTypes.TIMELINE_SUCCESS_PAST]: (state, { payload }) => {
      if (payload.past && payload.past.query) {
        return payload.past.query.date;
      }
      return '';
    },
  },
  '',
);

export const isLoadingPast = handleActions(
  {
    [actionTypes.TIMELINE_REQUEST_PAST]: () => true,
    [combineActions(
      actionTypes.TIMELINE_SUCCESS_PAST,
      actionTypes.TIMELINE_FAILURE_PAST,
    )]: () => false,
  },
  false,
);


export default combineReducers({
  items,
  isLoading,
  error,
  filters,
  statusses,
  objects,
  types,
  futureDate,
  pastDate,
  isInactive,
  isLoadingPast,
});
